import { render, staticRenderFns } from "./MonitorVideo.vue?vue&type=template&id=0b47f748&scoped=true&"
import script from "./MonitorVideo.vue?vue&type=script&lang=js&"
export * from "./MonitorVideo.vue?vue&type=script&lang=js&"
import style0 from "./MonitorVideo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MonitorVideo.vue?vue&type=style&index=1&id=0b47f748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b47f748",
  null
  
)

export default component.exports